(() => {
  if (customElements.get('dblc-look')) return;

  class DblcLook extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-dblc-look-track]');
      this.viewport = this.querySelector('[data-dblc-look-viewport]');
      this.prev = this.querySelectorAll('[data-dblc-look-prev]');
      this.next = this.querySelectorAll('[data-dblc-look-next]');
      this.index = 0;
      if (!this.track || !this.viewport) return;

      this.prev.forEach((button) => button.addEventListener('click', () => this.go(-1)));
      this.next.forEach((button) => button.addEventListener('click', () => this.go(1)));
      this.onResize = () => this.go(0, true);
      window.addEventListener('resize', this.onResize);
      this.go(0, true);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    slides() {
      return Array.from(this.track?.children || []).filter((node) => node.nodeType === 1);
    }

    slideWidth() {
      const item = this.slides()[0];
      return item ? item.getBoundingClientRect().width : this.viewport.getBoundingClientRect().width;
    }

    go(step, reset) {
      const slides = this.slides();
      if (!this.track || slides.length === 0) return;
      const max = Math.max(0, slides.length - 1);
      if (reset) this.index = Math.min(this.index, max);
      else this.index = Math.min(max, Math.max(0, this.index + step));

      this.track.style.transform = `translateX(${-(this.index * this.slideWidth())}px)`;

      this.prev.forEach((button) => {
        button.disabled = this.index <= 0;
      });
      this.next.forEach((button) => {
        button.disabled = this.index >= max;
      });
    }
  }

  customElements.define('dblc-look', DblcLook);
})();
